var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"my-0",attrs:{"dense":"","text":"","tile":"","border":"left","type":"warning","icon":"mdi-alert-outline"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }